import { render } from "./App.vue?vue&type=template&id=57ff3adc"
const script = {}

import "./App.vue?vue&type=style&index=0&id=57ff3adc&lang=scss"

import exportComponent from "/home/misha/Рабочий стол/demo-system-front-student/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__